module.exports = __webpack_public_path__ + "img/aeronautica_roma_hero_bg.80f2083f.png";